<template>
  <transition name="el-fade-in-linear">
  <div v-show="transitionshow">
	   
       <el-form :inline="true" class="backborder1 demo-form-inline" size="small">
          <el-form-item>
            <el-date-picker style="width:100%"
              v-model="query.date"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd" :unlink-panels="false" @change="query.ischange=true">
            </el-date-picker>
          </el-form-item>
          <el-form-item>
              <el-select v-model="query.customerid" clearable filterable remote reserve-keyword :remote-method="getCustomer" :loading="customerLoading" placeholder="客户名称 / 简称 / 客户手机" @change="query.ischange=true" style="width:100%">
		          <el-option v-for="(item,index) in customerLists" :key="index" :label="item.showname" :value="item.id"></el-option>
		      </el-select> 
          </el-form-item>
          <el-form-item>
              <el-select v-model="query.profittype" remote  filterable placeholder="按品牌" @change="query.ischange=true">	            
                  <el-option v-for="(item,index) in profittypelists" :label="item.name" :value="item.id" :key="index" />          
              </el-select>          
          </el-form-item>
          <el-form-item>
              <el-button type="primary" icon="el-icon-search"  @click="getlists">查询</el-button>
          </el-form-item>
       </el-form>

       <div class="cost-brand-warning" style="display:inline-block;width:calc(100% - 40px);min-height:20px;padding:5px 20px;background:#c6c4c4;margin-top:10px;border-radius:6px;">
           <div class="cost-brand-warning-info" style="float:left;width:100%;font-size:13px;line-height:21px;color:red">1、当前品牌销售信息均来自已完成的销售单，未完成、已审核的不在统计行列；</div>
           <div class="cost-brand-warning-info" style="float:left;width:100%;font-size:13px;line-height:21px;color:red">2、销售单商品销售总额=（订单总额 - 邮费 - 优惠金额）*（商品小计/订单总额），即销售单优惠金额会分摊到商品里进行统计；</div>
       </div>

       <div class="backborder2" style="margin-top:10px">
            <el-table :data="lists" :key="index" v-loading="query.loading">
                <el-table-column label="客户信息" align="left">
                    <template slot-scope="scope">
                        <div class="cost-brand-brandnames">{{scope.row.customername}}（电话：{{scope.row.customerphone}})</div>
                        <div class="cost-brand-id">ID：{{scope.row.id}}</div>
                    </template>  
                </el-table-column>
                <el-table-column label="销售订单数" width="120" align="center">
                    <template slot-scope="scope">
                        <div class="cost-brand-names">{{scope.row.counts}}</div>
                    </template>  
                </el-table-column>
                <el-table-column label="客单价" width="120" align="center">
                    <template slot-scope="scope">
                        <div class="cost-brand-names">{{scope.row.unitprice|CFMprice}}</div>
                    </template>  
                </el-table-column>
                <el-table-column label="下单金额" width="120" align="center">
                    <template slot-scope="scope">
                        <div class="cost-brand-names">{{scope.row.totals|CFMprice}}</div>
                    </template>  
                </el-table-column>
                <el-table-column label="销售额" width="120" align="center">
                    <template slot-scope="scope">
                        <div class="cost-brand-names">{{scope.row.reals|CFMprice}}</div>
                    </template>  
                </el-table-column>
                <el-table-column label="成本" width="120" align="center">
                    <template slot-scope="scope">
                        <div class="cost-brand-names">{{scope.row.costs|CFMprice}}</div>
                    </template>  
                </el-table-column>
                <el-table-column label="利润" width="120" align="center">
                    <template slot-scope="scope">
                        <div class="cost-brand-names">{{scope.row.profit|CFMprice}}</div>
                    </template>  
                </el-table-column>
                <el-table-column label="利润率" width="120" align="center">
                    <template slot-scope="scope">
                        <div class="cost-brand-names">{{scope.row.profitpercent|CFMprice}}%</div>
                    </template>  
                </el-table-column>
            </el-table>
            <div class="block">      		
            <!--分页begin-->
            <el-pagination
	            @size-change="productPageSizeChange"
	            @current-change="productPageCurrentChange"
	            :current-page="query.p"
	            :page-sizes="[10, 20, 50]"
	            :page-size="query.rollpage"
	            layout="total, sizes, prev, pager, next, jumper"
	            :total="query.rows">
            </el-pagination>
            <!--分页end-->
      	    </div>
       </div>
      
       
  </div>
  </transition>  
</template>

<script>

export default {
  data () {
    return {
      actionauth:'', //功能权限
      url:this.GLOBAL.domain+"Cost/index",
      transitionshow:true,
      query: {
          act:'getcustomercosts',
          token:this.$cookies.get('token'),
          customerid:'',
          date:[new Date().getFullYear().toString() + '-' + (new Date().getMonth()+1) + '-' + new Date().getDate(),new Date().getFullYear().toString() + '-' + (new Date().getMonth()+1) + '-' + new Date().getDate()],
          profitpercent:[],
          profittype:1,
          paytype:1,
          loading:false,
          ischange:false,
          rows:0,
          p:1,
          rollpage:10,
      },

      lists:[],
      brandlists:[],
      profittypelists:[{id:1,name:'利润由高到低排序'},{id:2,name:'利润由低到高排序'},{id:3,name:'利润率由高到低排序'},{id:4,name:'利润率由低到高排序'}],
      paytype:[{id:1,name:'线下开单'},{id:2,name:'小程序开单'},{id:3,name:'线上商城开单'},{id:4,name:'分销订单'}],
      customerLoading:false,
      customerLists:[],

    }  
  },

  filters: {
    /** 价格信息保留两位小数 **/
    CFMprice(value) {
       var price=parseFloat(value); //修剪去小数点后多余的0
       var numsobj=price.toString().split(".");	//判断小数点后有几位小数
       var result=0.00;

       if(numsobj.length==1) result=price.toFixed(2); //值为0时补充到2位
       if(numsobj.length > 1 && numsobj[1].length <= 2) result=price.toFixed(2); //值为小数点后只有1位小数时补充到2位
       if(numsobj.length > 1 && numsobj[1].length > 2) result=price; //小数点后的值超出2位时直接返回
       return result;		
    }
  },

  mounted(){
    this.getactionauth();
    this.getlists();  //获取记录信息
    
  },
  methods:{

     /** 获取品牌成本利润信息 **/
     getlists() {
         if(this.query.ischange) {
            this.query.p=1;
            this.query.rollpage=10;
        }

        this.query.loading=true;
        var resource = this.$resource(this.url);
            resource.save(this.query).then((res) => {
            if(res.data.Result>0){
                if(res.data.Result=='70001') this.$router.push('/login')
                this.$message.error(res.data.Message);
                this.query.loading=false;
            }else{
                this.lists = JSON.parse(Base64.decode(res.data.Data));
                this.query.rows=parseInt(res.data.count);
                this.query.loading=false;
                if(this.brandquery.ischange) this.brandquery.ischange=false;
            }
        }).catch((res) => {
            this.query.loading=false;
        });
    },

    productPageSizeChange(val) {
        this.query.rollpage = val;
        this.getlists();
    },
    productPageCurrentChange(val) {
        this.query.p = val;
        this.getlists();
    },


    /** 获取客户 **/
    getCustomer(key){
        if (key !== '') {
	        this.customerLoading = true;
	        var resource = this.$resource(this.GLOBAL.domain+"Customer/index");
	        resource.query({act:'lists',key:key,token:this.$cookies.get('token')}).then((res) => {
	            if(res.data.Result>0){
		            if(res.data.Result=='70001') this.$router.push('/login')
		            this.$message.error(res.data.Message);
		            this.customerLoading = false;
	            }else{
		            this.customerLists = JSON.parse(Base64.decode(res.data.Data));
		            this.customerLoading = false;
	            }
	        }).catch((res) => {
	            this.customerLoading = false;
	        });
        }
    },

    
    /** 获取功能操作权限 **/
    getactionauth() {
    	  var data =this.$cookies.get('actionauth');
    	  data=JSON.parse(data);
        this.actionauth=data;
    },
    
    
  }
}
</script>
<style>
.backborder1 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:1% 1% 0 1%}
.backborder3 {background:#fff;border-radius:15px;border:1px solid #ddd;float:left;width:98%;padding:1% 1% 0 1%;}
.cost-log-averages {float:left;width:100%;font-size:13px;line-height:23px;overflow:hidden;white-space: nowrap;text-overflow: ellipsis;}
.cost-log-averages-spec {float:left;font-size:12px;line-height:23px;color:#999999}
.cost-log-time {font-size:13px;line-height:23px;float:left;width:100%}
.cost-log-type {font-size:12px;line-height:21px;padding:1px 10px;border-radius:15px;margin:0 auto;margin-top:5px;}
.cost-log-type-in {background:#67c23a;color:#fff;display:inline-block;}
.cost-log-type-out {background:#f78989;color:#fff;display:inline-block;}
.cost-log-priceinfos {font-size:13px;line-height:23px}

.cost-log-gray {background:#909399}
.cost-brand-infos-out {display:flex;justify-content:center;align-items:center;width:80px;height:60px;border-radius:6px;background:rgba(221,221,221,.3);border:1px solid rgba(221,221,221,.7)}
.cost-brand-infos-info {max-width:85%;max-height:85%;border-radius:6px;}
.cost-brand-names {font-size:13px;}
.cost-brand-id {font-size:12px !important;float:left;width:calc(100% - 80px - 2px - 2%);line-height:23px;color:#999999;margin:0 0 0 2%}
</style>


// WEBPACK FOOTER //
// src/components/inventory/CustomerCostAccount.vue